import { take, call, put } from 'redux-saga/effects';
import { accounts as actionTypes } from '$constants/action-types';
import * as actions from '$actions/accounts';
import { errors } from '../lib/normalize';
import { browserHistory } from 'react-router';
import { alert } from './root';
import { showNotification } from '$actions/root';
import Cookies from 'js-cookie';
import axios from 'axios';
import { sendSlackMessage } from '../api';
import { Translate } from '$common';

const create = params => axios.post(`/customers`, params);
const login = params => axios.post(`/tokens`, params);
const recover = params => axios.post(`/reset_passwords`, params);
const resetPassword = params => axios.patch(`/reset_passwords/${params.token}`, params);
const fetchCurrent = () => axios.get(`/accounts/me`);

function* watchCreate() {
  while(true) {
    const action = yield take(actionTypes.CREATE);

    let companySize = [0, 99999999];
    if (action.params.companySize) {
      companySize = action.params.companySize.split('...');
    }

    try {
      const params = {
        customer: {
          first_name: action.params.first_name,
          last_name: action.params.last_name,
          email: action.params.email,
          password: action.params.password,
          customer_role_id: action.params.customer_role_id,
          locale: 'tr',
          time_zone: 'tr'
        },
        account_name: action.params.account,
        sector_id: action.params.sectorId || 1,
        company_size: "["+companySize[0].replace('+', '')+","+ (typeof companySize[1] === "undefined" ? 99999999 : companySize[1]-1)+"]"
      };
      
      if (action.params.account.trim() === "" || action.params.first_name.trim() === "" || action.params.last_name.trim() === "" || action.params.email.trim() === "" || action.params.password.trim() === "") {
        const errors = {
          company: action.params.account.trim() === "" ? [ 'can\'t be blank' ] : '',
          first_name: action.params.first_name.trim() === "" ? [ 'can\'t be blank' ] : '',
          last_name: action.params.last_name.trim() === "" ? [ 'can\'t be blank' ] : '',
          email: action.params.email.trim() === "" ? [ 'can\'t be blank' ] : '',
          password: action.params.password.trim() === "" ? [ 'can\'t be blank' ] : ''
        };
        yield put(actions.createFailure(errors));
      } else {
        const errors = null;
        yield put(actions.createFailure(errors));
        yield put(actions.createRequest());
        const { data } = yield call(create, params);
        if (process.twentify.indexOf(process.target[0]) !== -1 && process.target[0] !== "staging") {
          sendSlackMessage(`${params.customer.first_name} ${params.customer.last_name} isimli kullanıcı, ${params.account_name} hesabı için kayıt oldu. (${params.customer.email})`)
        }
        // window.Intercom('trackEvent', 'SIGNED_UP', { full_name: action.params.first_name +' '+ action.params.last_name, email: action.params.email, company: action.params.company });
        yield alert('Başarılı', 'Başarılı bir şekilde kayıt oldunuz.');
        Cookies.set('customer_signup', true, { expires: 365 });
      }

    } catch(e) {
      let messages = {}
      if (e.data) {
        messages = errors(e.data.data.messages);
      }
      const params = {
        ...messages,
        company: action.params.account.trim() === "" ? [ 'can\'t be blank' ] : '',
        sectorId: messages.sector,
        first_name: messages['first_name'],
        last_name: messages['last_name'],
        email: messages['email'],
        password: messages['password']
      };

      yield put(actions.createFailure(params));
    }
  }
}

function* watchLogin() {
  while(true) {
    const action = yield take(actionTypes.LOGIN);

    try {
      yield put(actions.loginRequest());
      const { data } = yield call(login, { customer: action.params });
      axios.defaults.headers.common['Authorization'] = data.data.token;
      // window.Intercom('trackEvent', 'LOGGED_IN', { full_name: action.params.first_name +' '+ action.params.last_name, email: action.params.email });
      yield put(actions.loginSuccess({ token: data.data.token, remember: action.params.remember }));
    } catch(e) {
      yield put(actions.loginFailure({ base: [Translate.get('email_or_password_incorrect')] }));
    }
  }
}

function* watchRecover() {
  while(true) {
    const action = yield take(actionTypes.RECOVER);

    try {
      const { data } = yield call(recover, { customer: action.params });
      const alertMessage = `In order to change your password please check your
        email and follow the instructions`;

      yield alert('Check your email', alertMessage);
      browserHistory.push('/');
    } catch(e) {
      yield put(actions.recoverFailure({ base: [Translate.get('email_or_password_incorrect')] }));
    }
  }
}

function* watchResetPassword() {
  while(true) {
    const action = yield take(actionTypes.RESET_PASSWORD);

    if (action.params.password !== action.params.passwordConfirmation) {
      yield put(actions.resetPasswordFailure({ passwordConfirmation: ['not match'] }));
      continue;
    }

    try {
      const { token, ...rest } = action.params;
      const { data } = yield call(resetPassword, { token, customer: rest });
      browserHistory.push('/');
      yield put(showNotification('Your password has been changed', 'success'));
    } catch(e) {
      yield put(actions.recoverFailure({ base: ['Something went wrong.'] }));
    }
  }
}

function* watchForAuthCookie() {
  while(true) {
    const actions = [actionTypes.CREATE_SUCCESS, actionTypes.LOGIN_SUCCESS];
    const action = yield take(actions);
    const expiration = action.result.remember ? 365 : null;

    axios.defaults.headers.common['Authorization'] = action.result.token;

    Cookies.set('token', action.result.token, { expires: expiration });
    browserHistory.push('/');
  }
}

function* watchLogout() {
  while(true) {
    yield take(actionTypes.LOGOUT);
    Cookies.remove('token');
    if (process.muhimma.indexOf(process.target[0]) !== -1) {
      browserHistory.push('/login');
    } else {
      window.location = 'https://live.twentify.com';
    }
  }
}

function* watchFetchCurrent() {
  while(true) {
    const action = yield take(actionTypes.FETCH_CURRENT);

    try { 
      yield put(actions.fetchCurrentRequest());
      const { data } = yield call(fetchCurrent);
      yield put(actions.fetchCurrentSuccess(data.data));
    } catch (e) {
      console.log(e);
    }
  }
}

export const watchers = [
  watchCreate,
  watchLogin,
  watchForAuthCookie,
  watchLogout,
  watchRecover,
  watchResetPassword,
  watchFetchCurrent
];



// WEBPACK FOOTER //
// ./src/sagas/accounts.js